/**
 * Kiểu dữ liệu trả về cho validator theo chuẩn Signals Forms (Angular 21)
 */
export interface SignalValidationError {
  kind: string;
  message: string;
}

/**
 * Validator cho thông tin liên hệ: Chấp nhận Email hoặc Số điện thoại (Việt Nam)
 * Được thiết kế tối ưu cho Signals Forms và Clean Code.
 *
 * @param value Giá trị chuỗi cần kiểm tra
 * @returns SignalValidationError nếu không hợp lệ, ngược lại null
 */
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PHONE_PATTERN = /^(0|\+84)(\d{9,10})$/;

export function emailValidator(
  value: string | null | undefined,
): SignalValidationError | null {
  const trimmedValue = value?.trim();
  if (!trimmedValue) return null;
  return EMAIL_PATTERN.test(trimmedValue)
    ? null
    : { kind: 'email', message: 'VALIDATION.EMAIL' };
}

export function phoneValidator(
  value: string | null | undefined,
): SignalValidationError | null {
  const trimmedValue = value?.trim();
  if (!trimmedValue) return null;
  return PHONE_PATTERN.test(trimmedValue)
    ? null
    : { kind: 'phone', message: 'VALIDATION.INVALID_PHONE' };
}

export function contactValidator(
  value: string | null | undefined,
): SignalValidationError | null {
  const trimmedValue = value?.trim();

  if (!trimmedValue) {
    return null; // Không validate nếu rỗng (để required() xử lý)
  }

  if (EMAIL_PATTERN.test(trimmedValue) || PHONE_PATTERN.test(trimmedValue)) {
    return null;
  }

  // Phân loại lỗi để cung cấp message chính xác
  if (trimmedValue.includes('@')) {
    return {
      kind: 'invalidContact',
      message: 'VALIDATION.EMAIL',
    };
  }

  if (/^\d|\+/.test(trimmedValue)) {
    return {
      kind: 'invalidContact',
      message: 'VALIDATION.INVALID_PHONE',
    };
  }

  return {
    kind: 'invalidContact',
    message: 'VALIDATION.INVALID_CONTACT',
  };
}

/**
 * Regex kiểm tra độ mạnh mật khẩu:
 * - Ít nhất 8 ký tự
 * - Có chữ hoa, chữ thường
 * - Có số
 * - Có ký tự đặc biệt
 */
export const PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

/**
 * Validator kiểm tra độ mạnh mật khẩu theo chuẩn Signals Forms
 */
export function passwordValidator(
  value: string | null | undefined,
): SignalValidationError | null {
  if (!value) {
    return null;
  }

  return PASSWORD_PATTERN.test(value)
    ? null
    : {
        kind: 'passwordWeak',
        message: 'VALIDATION.PASSWORD_WEAK',
      };
}
